import React from 'react';
import styles from './css/StickyGbCta.styl';
import _isFunction from 'lodash/isFunction';
import _isNil from 'lodash/isNil';
import {getGATags} from '../../../../shared/utilities/GAHelpers';
import {bindMethods} from '../../../../shared/utilities/componentHelpers';

export default class StickyGbCta extends React.Component {
  static propTypes = {
    display: React.PropTypes.bool,
    getGuestBookPosition: React.PropTypes.func,
    guestBookHandler: React.PropTypes.func,
    hasSubmitted: React.PropTypes.bool,
    isSingleColumn: React.PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      display: this.props.display || false,
    };

    bindMethods(this, ['handleClick', 'handleScroll', 'handleModalOpen']);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    if (
      !_isNil(nextProps.display) &&
      this.state.display !== nextProps.display
    ) {
      this.setState({display: nextProps.display});
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  /**
   * scroll event handler
   * @return {undefined} returns nothing
   */
  handleScroll() {
    const position = _isFunction(this.props.getGuestBookPosition)
      ? this.props.getGuestBookPosition()
      : 0;

    if (position < -350) {
      if (!this.state.display) {
        this.setState({display: true});
      }
    } else if (this.state.display) {
      this.setState({display: false});
    }
  }

  /**
   * click event handler
   * @return {undefined} returns nothing
   */
  handleClick() {
    if (_isFunction(this.props.guestBookHandler)) {
      this.props.guestBookHandler();

      getGATags({
        eventCategory: 'bypage_person',
        eventAction: 'sign_guest_book_stickynav',
        eventLabel: 'onpage',
      });
    }
  }

  render() {
    return !this.props.hasSubmitted && this.props.isSingleColumn ? (
      <div
        className={`${styles.StickyGbCta}${
          this.state.display ? ` ${styles.display}` : ''
        }`}
        onClick={this.handleClick}
      >
        Sign Guest Book
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/StickyGbCta.js